import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getGstOneInvoiceListApi,
  getGstOneListApi,
  getGstThreeBInvoiceListAPi,
  getGstr2aReturnsApi,
  getGstr2bReturnsApi,
  getGstrOnehsnWiseCountApi,
  getGstrTreeBListApi,
  getInwardsListApi,
  getOutwardsListApi,
  postOneFilingSendOTPApi,
  postGstrOneFilingSaveDataApi,
  requestGstrOtpApi,
  updateInwardsListApi,
  updateOutwardsListApi,
  verifyGstrOtpApi,
  getGstNumberListApi,
  approveGstApi,
  gstPostComment,
  gstGetAllCommentApi,
  postGstrThreeFillingMappingApi,
  postGstOneCompleteFilingApi,
  postGstOneProceedFilingApi,
  postGstrOneFilingResetSaveDataApi,
  GstrOneFilingSatusApi,
  getGstr2a2bCompareApi,
  postARNNumberApi,
} from "../../apis/gstModuleApis";
import {
  GetGstrThreeBListPayloadType,
  GetGstrTwoAListPayloadType,
  GetGstrTwoBListPayloadType,
  GetOutwardDataPayload,
  GstrOnePayload,
  GstrOnehsnWiseCountPayload,
  GstrThreeBInvoiceListPayload,
  PostGstrOneSaveDataType,
  GstrFilingSendOTPPayload,
  PostGstrOneCompleteFilingType,
  RequestGstOtpPayloadType,
  UpdateOutwardDataPayload,
  VerifyGstOtpPayloadType,
  GetGstNumberPayload,
  ApproveGstPayloadType,
  GstCommentPayloadType,
  GstGetAllCommentPayloadType,
  PostGstrOneProceedType,
  GstrOneSatusType,
  GetGstrTwoATwoBComparePayloadType,
  ARNNumberPayloadType,
} from "../../commonTypes/gstTypes";

export const getOutwardsListAction = createAsyncThunk(
  "gstModule/getOutwardsList",
  async (data: GetOutwardDataPayload) => {
    const response = await getOutwardsListApi(data);
    return response.data;
  }
);

export const updateOutwardListAction = createAsyncThunk(
  "gstModule/updateOutwardsList",
  async (data: UpdateOutwardDataPayload) => {
    const response = await updateOutwardsListApi(data);
    return response.data;
  }
);

export const getInwardsListAction = createAsyncThunk(
  "gstModule/getInwardsList",
  async (data: GetOutwardDataPayload) => {
    const response = await getInwardsListApi(data);
    return response.data;
  }
);

export const updateInwardsListAction = createAsyncThunk(
  "gstModule/updateInwardsList",
  async (data: UpdateOutwardDataPayload) => {
    const response = await updateInwardsListApi(data);
    return response.data;
  }
);

export const getGstrOneListAction = createAsyncThunk(
  "gstModule/getGstrOneList",
  async (data: GstrOnePayload) => {
    const response = await getGstOneListApi(data);
    return response.data;
  }
);

export const getGstrOneInvoiceListAction = createAsyncThunk(
  "gstModule/getGstrOneInvoiceList",
  async (data: GstrOnePayload) => {
    const response = await getGstOneInvoiceListApi(data);
    return response.data;
  }
);

export const getGstThreebInvoiceListAction = createAsyncThunk(
  "gstModule/getGstrThreeBInvoiceList",
  async (data: GstrThreeBInvoiceListPayload) => {
    const response = await getGstThreeBInvoiceListAPi(data);
    return response.data;
  }
);

export const getGstrOnehsnWiseCountAction = createAsyncThunk(
  "gstModule/getGstrOnehsnWiseCount",
  async (data: GstrOnehsnWiseCountPayload) => {
    const response = await getGstrOnehsnWiseCountApi(data);
    return response.data;
  }
);

export const getGstrThreeBListAction = createAsyncThunk(
  "get/gstrThreeB",
  async (data: GetGstrThreeBListPayloadType) => {
    const response = await getGstrTreeBListApi(data);
    return response.data;
  }
);

export const requestGstOtpAction = createAsyncThunk(
  "request/otp",
  async (data: RequestGstOtpPayloadType) => {
    const response = await requestGstrOtpApi(data);
    return response.data;
  }
);

export const verifyGstOtpAction = createAsyncThunk(
  "verify/otp",
  async (data: VerifyGstOtpPayloadType) => {
    const response = await verifyGstrOtpApi(data);
    return response.data;
  }
);

export const getGstrTwoAReturnsListAction = createAsyncThunk(
  "get/gstr2a/returns",
  async (data: GetGstrTwoAListPayloadType) => {
    const response = await getGstr2aReturnsApi(data);
    return response.data;
  }
);
export const getGstrTwoATwoBCompareListAction = createAsyncThunk(
  "get/gstr2a2b/compare/expense",
  async (data: GetGstrTwoATwoBComparePayloadType) => {
    const response = await getGstr2a2bCompareApi(data);
    return response.data;
  }
);

export const getGstrTwoBReturnsListAction = createAsyncThunk(
  "get/gstr2b/returns",
  async (data: GetGstrTwoBListPayloadType) => {
    const response = await getGstr2bReturnsApi(data);
    return response.data;
  }
);

export const postGstrOneFilingSaveDataAction = createAsyncThunk(
  "post/gstrOne/filing/mapping",
  async (data: PostGstrOneSaveDataType) => {
    const response = await postGstrOneFilingSaveDataApi(data);
    return response.data;
  }
);

export const postGstrThreeBFilingMappingAction = createAsyncThunk(
  "post/gstrTHreeB/filing/mapping",
  async (data: PostGstrOneSaveDataType) => {
    const response = await postGstrThreeFillingMappingApi(data);
    return response.data;
  }
);

export const postGstrOneFilingSendOTPAction = createAsyncThunk(
  "get/gstrOne/filing/otp/send",
  async (data: GstrFilingSendOTPPayload) => {
    const response = await postOneFilingSendOTPApi(data);
    return response.data;
  }
);

export const postGstrOneCompleteFilingAction = createAsyncThunk(
  "post/gstrOne/filing/otp",
  async (data: PostGstrOneCompleteFilingType) => {
    const response = await postGstOneCompleteFilingApi(data);
    return response.data;
  }
);

export const gstOneProceedFileAction = createAsyncThunk(
  "post/gstrOne/proceed",
  async (data: PostGstrOneProceedType) => {
    const response = await postGstOneProceedFilingApi(data);
    return response.data;
  }
);

export const getGstNumberList = createAsyncThunk(
  "get/gst/number",
  async (data: GetGstNumberPayload) => {
    const response = await getGstNumberListApi(data);
    return response.data;
  }
);

export const approveGstAction = createAsyncThunk(
  "post/gst/approve",
  async (data: ApproveGstPayloadType) => {
    const response = await approveGstApi(data);
    return response.data;
  }
);

export const gstPostCommentAction = createAsyncThunk(
  "/gst/post/comments",
  async (data: GstCommentPayloadType) => {
    const response = await gstPostComment(data);
    return response.data;
  }
);

export const gstGetAllCommentAction = createAsyncThunk(
  "/gst/get/all/comments",
  async (data: GstGetAllCommentPayloadType) => {
    const response = await gstGetAllCommentApi(data);
    return response.data;
  }
);

export const postGstrOneFilingResetSaveDataAction = createAsyncThunk(
  "/post/gstrOne/reset/save",
  async (data: PostGstrOneSaveDataType) => {
    const response = await postGstrOneFilingResetSaveDataApi(data);
    return response.data;
  }
);
export const gstOneFilingStatus = createAsyncThunk(
  "/get/gstrOne/status",
  async (data: GstrOneSatusType) => {
    const response = await GstrOneFilingSatusApi(data);
    return response.data;
  }
);
export const postARNNumberAction = createAsyncThunk(
  "/post/arn/number",
  async (data: ARNNumberPayloadType) => {
    const response = await postARNNumberApi(data);
    return response.data;
  }
);
